<template>
  <j-modal
    :title="language['system.languageManagement']"
    :width="700"
    :visible="visible"
    switchFullscreen
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model>
        <div v-for="(item,index) in languagelist" :key="index">
          <a-form-model-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            :label="language[item.templateLangCode]">
            <a-input type="text" v-model="item.langTrans" maxLength="maxLength" :disabled="isDisabled||disabled"/>
          </a-form-model-item>
        </div>
      </a-form-model>
    </a-spin>
  </j-modal>

</template>

<script>
import { getAction } from '@api/manage'

const newLanguagelist=[
  {templateLangCode:'zh_CN',langTrans:''},
  {templateLangCode:'zh_TW',langTrans:''},
  {templateLangCode:'en_US',langTrans:''},
  {templateLangCode:'vi_VN',langTrans:''},
]


export default {
  name: "LanguageModel",
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    //表单禁用
    maxLength: {
      type: Number,
      default: 100000,
      required: false
    }
  },
  data(){
    return {
      visible: false,
      confirmLoading: false,

      props: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      languagelist:[
        {templateLangCode:'zh_CN',langTrans:''},
        {templateLangCode:'zh_TW',langTrans:''},
        {templateLangCode:'en_US',langTrans:''},
        {templateLangCode:'vi_VN',langTrans:''},
      ],

      applicationId:'',
      dataTable:'',
      dataColumn:'',
      dataId:'',
      isDisabled:false,
    }
  },
  created() {
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
  },
  methods:{
    edit(applicationCode,dataTable,dataColumn,dataId,languagelist,props,isDisabled){
      this.props = props
      console.log("11111",languagelist)
      getAction("/sys/sysBmApplication/queryByCode",{"code":applicationCode}).then((res) => {
        console.log("2222")
        if(res.success){
          console.log("333333")
          if(isDisabled){
            this.isDisabled = isDisabled;
          }
          this.visible = true
          this.applicationId = res.result.id
          this.dataTable = dataTable
          this.dataColumn = dataColumn
          this.dataId = dataId
          console.log("1111111100000",newLanguagelist)
          this.languagelist = JSON.parse(JSON.stringify(newLanguagelist))
          console.log("this.languagelist00000",newLanguagelist)
          console.log("this.languagelist1111",this.languagelist)
          if(languagelist && languagelist.length>0){
            this.languagelist = languagelist
            console.log("this.languagelist22222",this.languagelist,dataId)
          }else{
            this.initLanguagetemp("esg",dataTable,dataColumn,dataId)
          }
          console.log("this.languagelist",languagelist,this.languagelist,dataId)

        }
      })


    },
    handleOk(){
      let list = [];
      this.languagelist.forEach(item=>{
          item.applicationId = this.applicationId
          item.dataTable = this.dataTable
          item.dataColumn = this.dataColumn
          item.dataId = this.dataId
          item.langTrans = item.langTrans?item.langTrans.trim():'';
          list.push(item);
      })
      let map = {
        props: this.props,
        applicationId:this.applicationId,
        dataTable:this.dataTable,
        dataColumn:this.dataColumn,
        dataId:this.dataId,
        languagelist:list
      }
      this.$emit('ok',map);
      this.close();
    },
    handleCancel(){
      this.close();
    },
    close(){
      this.visible = false
    },
    initLanguagetemp(applicationCode,dataTable,dataColumn,dataId){
      let that = this;
      getAction("/sys/syslanguagedata/querylistby", {applicationCode:applicationCode,dataTable:dataTable,dataColumn:dataColumn,dataId:dataId}).then((res)=>{
        if(res.success){
          this.languagelist = res.result;
        }else{
        }
      });
    },
  }
}
</script>

<style scoped>

</style>